"use client";

import { useEffect } from "react";
import { captureErrorBoundary } from "@/lib/utils/captureErrorBoundary";
import Link from "next/link";

export default function AboutUsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureErrorBoundary(error, "about-us", "/about-us");
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center p-8 max-w-md">
        <h2 className="text-3xl font-['Font-Bold'] text-(--text-headline) mb-4">
          About page unavailable
        </h2>
        <p className="text-(--text-muted) mb-6">
          We couldn&apos;t load this page. Please try again or contact us if the problem persists.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-(--gold) text-(--text-on-gold) rounded-lg hover:opacity-90 transition-opacity font-semibold"
          >
            Try again
          </button>
          <Link
            href="/"
            className="px-6 py-3 bg-(--purple) text-(--gold) rounded-lg hover:opacity-90 transition-opacity font-semibold"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
